const ENDPOINTS = {
  // baseUrl
  BASE_URL: process.env.REACT_APP_BASE_URL,

  // permission groups
  GET_CREATE_SCREEN: "permission-group",
  GET_UPDATE_DELETE_SCREEN: (id: string) => `permission-group/${id}`,

  // permissions
  GET_CREATE_PERMISSION: "permission",
  GET_UPDATE_DELETE_PERMISSION: (id: string) => `permission/${id}`,
  GET_GROUPED_PERMISSION: "permission/grouped",
  GET_PERMISSION_TREE: "permission/permission-tree",

  // roles
  GET_CREATE_ROLE: "role",
  GET_UPDATE_DELETE_ROLE: (id: string) => `role/${id}`,

  // role types
  GET_CREATE_ROLE_TYPE: "role-type",
  GET_UPDATE_DELETE_ROLE_TYPE: (id: string) => `role-type/${id}`,

  // user types
  GET_USER_TYPE: (withSuperAdmin: number) =>
    withSuperAdmin ? `user-type?withSuperAdmin=${withSuperAdmin}` : "user-type",
  CREATE_USER_TYPE: "user-type",
  GET_UPDATE_DELETE_USER_TYPE: (id: string) => `user-type/${id}`,

  // users
  LOGIN: "user/login",
  GET_CREATE_USER: "user",
  GET_UPDATE_DELETE_USER: (id: string) => `user/${id}`,
  CREATE_BULK_USERS: "user/bulk-import",
  RESET_USER_PASSWORD: `user/reset-password`,
  CHANGE_USER_PASSWORD: `user/change-account-password`,
  DELETE_BULK_USERS: "user/bulk-delete",
  GET_DEPARTMENT_MANAGERS: "user/managers",
  UPDATE_LANGUAGE: "user/update-language",
  UPDATE_FCM_TOKEN: "user/update-fcm-token",
  REMOVE_FCM_TOKEN: "user/fcm-token",

  // regulation categories
  GET_CREATE_REGULATION_CATEGORIES: "regulation-category",
  GET_UPDATE_DELETE_REGULATION_CATEGORIES: (id: string) =>
    `regulation-category/${id}`,

  // regulation certificates
  GET_CREATE_REGULATION_CERTIFICATES: "regulation-certificate",
  GET_UPDATE_DELETE_REGULATION_CERTIFICATES: (id: string) =>
    `regulation-certificate/${id}`,

  // regulation demanding authorities
  GET_CREATE_REGULATION_DEMANDING_AUTHORITIES: "regulation-demanding-authority",
  GET_UPDATE_DELETE_REGULATION_DEMANDING_AUTHORITIES: (id: string) =>
    `regulation-demanding-authority/${id}`,

  // regulation service providers
  GET_CREATE_REGULATION_SERVICE_PROVIDERS: "regulation-service-provider",
  GET_UPDATE_DELETE_REGULATION_SERVICE_PROVIDERS: (id: string) =>
    `regulation-service-provider/${id}`,

  // regulations
  GET_CREATE_REGULATION: "regulation",
  GET_UPDATE_DELETE_REGULATION: (id: string) => `regulation/${id}`,
  RENEW_REGULATION: (id: string) => `regulation/renew/${id}`,

  // text-entry
  CREATE_TEXT_ENTRY: "text-entry",
  GET_ALL_TEXT_ENTRIES: (locale: string, search: string) => {
    if (locale && search) {
      return `text-entry?locale=${locale}&search=${search}`;
    } else if (locale) {
      return `text-entry?locale=${locale}`;
    } else if (search) {
      return `text-entry?search=${search}`;
    } else {
      return `text-entry`;
    }
  },
  GET_UPDATE_DELETE_TEXT_ENTRY: (id: string) => `text-entry/${id}`,

  // uploader
  UPLOAD_IMAGES: "/upload/images",
  UPLOAD_VIDEOS: "/upload/videos",
  UPLOAD_FILES: "/upload/files",

  // departments
  GET_CREATE_DEPARTMENT: "department",
  GET_UPDATE_DELETE_DEPARTMENT: (id: string) => `department/${id}`,

  // checklist
  GET_CREATE_CHECKLIST: "checklist",
  GET_UPDATE_DELETE_CHECKLIST: (id: string) => `checklist/${id}`,
  ADD_CHECKLIST_COMMENT: (id: string) => `checklist/${id}/comment`,
  GET_CHECKLIST_BY_SHIFT_ID: `checklist/shift`,
  BULK_IMPORT_CHECKLIST: "checklist/bulk/import",
  BULK_ARCHIVE_CHECKLIST: "checklist/bulk/location-status",

  // announcements
  GET_CREATE_ANNOUNCEMENT: "announcements",
  GET_ANNOUNCEMENTS_BY_IDS: "announcements/by-ids",
  GET_ANNOUNCEMENT_STATS: "announcements/stats",
  GET_BRIEF_ANNOUNCEMENT: "announcements/brief",
  BULK_DELETE_ANNOUNCEMENTS: "announcements/bulk-delete",
  GET_UPDATE_DELETE_ANNOUNCEMENT: (id: string) => `announcements/${id}`,
  SOFT_DELETE_ANNOUNCEMENT: (id: string) => `announcements/${id}/soft-delete`,
  GET_ALL_ANNOUNCEMENTS_BY_DATE: (date: string) => `announcements/date/${date}`,
  READ_ANNOUNCEMENT: (id: string) => `announcement-read-status/${id}/read`,
  GET_RESERVATION_ZONES: "reservation-zones",
  GET_BRIEF_GROUP_ANNOUNCEMENT: "announcements/brief-group",

  // announcement tasks
  UPDATE_DELETE_ANNOUNCEMENT_TASK: (id: string) => `announcements/task/${id}`,

  // announcement responders
  TOGGLE_ANNOUNCEMENT_RESPONDER: (id: string) =>
    `announcement-responders/${id}`,

  // announcement task comments
  CREATE_ANNOUNCEMENT_TASK_COMMENT: (id: string) => `announcements/task/${id}`,
  UPDATE_DELETE_ANNOUNCEMENT_TASK_COMMENT: (id: string) =>
    `announcements/comment/${id}`,

  // forms
  GET_CREATE_FORM: "forms",
  GET_FORMS_BY_IDS: "forms/by-ids",
  BULK_CHANGE_FORM_STATUS: "forms/bulk-change-status",
  GET_CREATE_FORM_WITH_ANSWERS: (formId: string) => `forms/${formId}/answers`,
  UPDATE_FORM: (formId: string) => `forms/${formId}`,
  GET_FORM_BY_ID: (formId: string) => `forms/${formId}`,
  SHARE_FORM: (formId: string) => `/forms/share/${formId}`,

  // equipments
  GET_CREATE_EQUIPMENT: "equipment",

  // clients
  GET_CREATE_CLIENT: "clients",
  GET_USER_CLIENT: "clients/user-clients",

  // branches
  GET_BRANCHES_BY_CLIENT: (clientId: string) => `branches/client/${clientId}`,

  // user groups
  GET_CREATE_USER_GROUP: "user-group",
  GET_UPDATE_DELETE_USER_GROUP: (id: string) => `user-group/${id}`,

  // shifts
  GET_CREATE_SHIFT: "shift",
  // notifications
  GET_NOTIFICATIONS: "notifications",
  // GET_UNREAD_NOTIFICATION_COUNT: "notifications/unread-count",
  // MARK_NOTIFICATION_AS_READ: (id: string) => `notifications/${id}/read`,
  MARK_ALL_NOTIFICATIONS_AS_READ: "notifications/mark-all-read",
  DELETE_NOTIFICATION: (id: string) => `notifications/${id}`,
  DELETE_SELECTED_NOTIFICATIONS: "notifications/selected",
  // DELETE_ALL_NOTIFICATIONS: "notifications/all",

  // day summary
  GET_DAY_SUMMARY: "summary",
  GET_DAY_SUMMARY_STATUS: "summary/status",
  ACKNOWLEDGE_DAY_SUMMARY: "summary/acknowledge",

  // on-boarding
  GET_UPSERT_ON_BOARDING_DRAFT: "on-boarding",
  GET_ADMIN_ON_BOARDING_DRAFTS: "on-boarding/admin/drafts",
  DELETE_ADMIN_ON_BOARDING_DRAFT: (draftId: string) =>
    `on-boarding/${draftId}`,
  UPDATE_ADMIN_LOCATION_STATUS: (locationType: string, locationId: string) =>
    `on-boarding/admin/locations/${locationType}/${locationId}/status`,
  ARCHIVE_ADMIN_LOCATION: (locationType: string, locationId: string) =>
    `on-boarding/admin/locations/${locationType}/${locationId}/archive`,
  ACTIVATE_ON_BOARDING_DRAFT: "on-boarding/activate",
  CHECK_EMAILS_EXIST: "user/check-emails-exist",
};

export default ENDPOINTS;
